<template>
	<v-app>
		<app-navigation-drawer
			v-if="navMobile"
			:value="drawer"
			:nav-links="navLinks"
			@toggle="drawer = !drawer"
		/>

		<app-toolbar
			:nav-links="navLinks"
			@toggle="drawer = !drawer"
		/>

		<v-content>
			<app-jumbotron />

			<app-programs class="py-5" />

			<app-footer />
		</v-content>
	</v-app>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue'
import AppJumbotron from '@/components/AppJumbotron.vue'
import AppNavigationDrawer from '@/components/AppNavigationDrawer.vue'
import AppPrograms from '@/components/AppPrograms.vue'
import AppToolbar from '@/components/AppToolbar.vue'

export default {
	components: {
		AppFooter,
		AppJumbotron,
		AppNavigationDrawer,
		AppPrograms,
		AppToolbar,
	},

	data: () => ({
		navLinks: [
			{ text: 'Programs', href: '#programs' },
			{ text: 'Tuition',  href: '/res/allstarkidsacademy-tuition-rates.pdf' },
			{ comp: () => import('@/components/AppForms.vue') },
			{ text: 'PROMOTION', href: '/res/allstarkidsacademy-promotion.pdf' },
		],
		drawer: false,
	}),

	computed: {
		navMobile() {
			return this.$vuetify.breakpoint.smAndDown
		},
	},
}
</script>

<style>
body, p, .application {
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
	font-size: 105%;
}
p, p *, ul, ol {
	color: #555;
}
img {
	max-width: 100%;
}
.w-50 {
	max-width: 50%;
}
.equalize {
	flex-direction: column;
	height: 100%;
}
.vertical-center-items * {
	display: inline;
	vertical-align: middle;
}
.para-justified {
	text-align: justify;
	text-align-last: center;
}
a[href='/res/allstarkidsacademy-promotion.pdf'] {
	color: #EF5350 !important;
	font-weight: bold;
}
</style>
